import React from 'react';

const Loading = ({ message = 'Cargando...', size = 'md', fullScreen = false }) => {
    const sizes = {
        sm: 'h-4 w-4',
        md: 'h-8 w-8',
        lg: 'h-12 w-12'
    };

    if (fullScreen) {
        return (
            <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
                <div className={`animate-spin rounded-full border-b-2 border-blue-600 ${sizes[size]}`}></div>
                <p className="mt-4 text-gray-600">{message}</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center p-8 bg-white">
            <div className={`animate-spin rounded-full border-b-2 border-blue-600 ${sizes[size]}`}></div>
            <p className="mt-4 text-gray-600">{message}</p>
        </div>
    );
};

export default Loading;
